module.exports = __webpack_public_path__ + "static/media/90088.705c1e0d.png";